export const INVALID_EMAIL = 'Please input a valid email';

export const BUSINESS_NOT_SELECTED = 'Please select a Business from the dropdown';

export const BUSINESS_ADDRESS_NOT_SELECTED = 'Please select a Business Address from the dropdown';
export const BUSINESS_NOT_FILLED = 'Please input a valid Business Name';

export const REFERRAL_EMAIL_KEY = 'RepEmail';

export const DEFAULT_REFERRAL_SOURCE = 'Inbound';

export const UTM_SOURCE_KEY = 'utm_source';
export const UTM_MEDIUM_KEY = 'utm_medium';
export const UTM_CAMPAIGN_KEY = 'utm_campaign';
export const UTM_TERM_KEY = 'utm_term';
export const UTM_CONTENT_KEY = 'utm_content';
export const UTM_ID_KEY = 'utm_id';
export const DEFAULT_UTM_SOURCE = 'Fisherman Website';
export const DEFAULT_UTM_MEDIUM = 'Form';
